import React, { Component } from "react";
import queryString from "query-string";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { onLoadVerifyTg30User } from "../../modules/actions/";

class Tg30UserVerification extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      email: "",
      password: "",
      disableLogin: false,
    };
  }

  componentDidMount = async () => {
    const { location } = this.props;
    const { search } = location;
    let queries = queryString.parse(search);

    const res = this.props.onLoadVerifyTg30User({
      queries,
      history: this.props.history,
    });

    console.log("RES", res);
  };

  render() {
    const { email, password, disableLogin } = this.state;

    return "Loading ...";
  }
}

const mapStateToProps = (state) => {
  return {
    res: state.authStore.res,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ onLoadVerifyTg30User }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Tg30UserVerification);
